import { CommentItem } from "pages/api/discuss/debate/[discussId]";
import DebateUserProfile from "./Comment/Profile";
import DebateContentIndex from "./Comment/Content/Index";
import { useRouter } from "next/router";
import CommentList from "./MainCommentList";
import { useDebateContext } from "contexts/DebateContext";
import { useParams } from "next/navigation";
import { useDiscussIdContext } from "contexts/DiscussIdContext";

// 토론 디테일 의견 레이아웃
function MainOpinionTemplete({ data }: { data: CommentItem }) {
  const router = useRouter();
  const { openComments } = useDebateContext();
  const { discussId, slug } = useDiscussIdContext();
  const isOpen = openComments.has(data?.comment_id);

  return (
    <div
      className="gap-2 flex items-stretch "
      data-test-id="main-opinion-templete"
      data-id={data?.comment_id}
    >
      <div className="flex flex-col ">
        <DebateUserProfile data={data} type="opinion" />
      </div>
      <div
        className="flex flex-col grow "
        style={{
          width: "calc(100% - 35px)",
        }}
      >
        <div className="flex flex-col gap-2 w-[100%]">
          <div
            data-test-id="main-opinion-templete-content"
            data-id={data?.comment_id}
            className={`flex flex-col gap-1 py-2 h-full cursor-pointer w-[100%]`}
            onClick={() => {
              router.push(
                `/discuss/${
                  slug ? `${slug}-${discussId}` : discussId
                }/opinion/${data?.comment_id}`
              );
            }}
            data-gtm-id={`report-opinion-content`}
          >
            <DebateContentIndex data={data} type="opinion" />
          </div>
          {isOpen && (
            <CommentList
              opinionId={data?.comment_id}
              parentUser={data?.email}
              commentCount={data?.comment_count}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default MainOpinionTemplete;
